import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
export const AEODetailsApi = createApi({
  reducerPath: "AEODetailsApi",
  baseQuery,
  tagTypes: ["AEODetails"],
  endpoints: (builder) => ({

    createAEODetails: builder.mutation({
        query: ({ id, ...data }) => ({
          url: `customers/aeo/${id}`,
          method: "PUT",
          headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
          body: { aeo: data },
       
        }),
        invalidatesTags: ["AEODetails"],
      }),
      

    getAEODetailsbyId: builder.query({
      query: ({ id }) => `customers/aeo/${id}`,
      transformResponse: (response) => {
        const data = response?.data ?? [];
        const normalized = Array.isArray(data) ? data : [data];
        return normalized.map((item) => ({
          ...item,
          id: item.customAeoId,
        }));
      },
      providesTags: ["AEODetails"],
    }),
    
  })
});
export const {
    useCreateAEODetailsMutation,
    useLazyGetAEODetailsbyIdQuery,
} = AEODetailsApi;


